import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import { GetShareLinkResponse, RemoveShareTokenResponse } from "../models/api-types";

/**
 * Chat Share Link API Hook
 * 
 * Conversation'ı public yaparak paylaşım linki oluşturur
 * veya mevcut linki döndürür.
 */
export const useGetShareLink = (
  options?: UseMutationOptions<GetShareLinkResponse, Error, string>
) => {
  return useMutation<GetShareLinkResponse, Error, string>({
    mutationFn: (conversationId: string) =>
      queryService.getShareLink(conversationId),
    ...options,
  });
};

/**
 * Chat Share Link Disable API Hook
 *
 * Conversation'ın shareToken'ını kaldırarak public paylaşımı kapatır.
 */
export const useRemoveShareToken = (
  options?: UseMutationOptions<RemoveShareTokenResponse, Error, string>
) => {
  return useMutation<RemoveShareTokenResponse, Error, string>({
    mutationFn: (conversationId: string) =>
      queryService.removeShareToken(conversationId),
    ...options,
  });
};

